import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation } from 'swiper/core';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import { toast } from 'react-toastify';
import { Button, Modal } from 'react-bootstrap';
import { useQuery, useQueryClient, useMutation } from 'react-query';
import Select from 'react-select';
import { useLocalStorage } from 'react-use';
import CenteredSpinner from './CenteredSpinner';
import Moment from 'react-moment';
import { useDispatch } from 'react-redux';
import { singlePropertyMap } from '../redux/action';
import noImage from '../images/noimage.png';
import { Clock, Heart, MapPin, Map, Share2, UserPlus, DollarSign, Navigation as NavigationIcon, Image, Calendar, FileText } from 'react-feather';
import * as AppConstants from '../AppConstants';
import { getSysSetting, numberWithCommas } from '../Utils';
import { UpdateNextAvailableDateModal } from './modals/UpdateNextAvailableDateModal';
import { OwnerLastContactModal } from './modals/OwnerLastContactModal';
import moment from 'moment-timezone';

SwiperCore.use([Pagination, Navigation]);

export const PropertyDetails = (props) => {
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [showPriceModal, setShowPriceModal] = useState(false);
  const [reason, setReason] = useState(null);
  const [comment, setComment] = useState(null);
  const queryClient = useQueryClient();
  const [reasonError, setReasonError] = useState(null);
  const [showUpdateOwnerLastContactModal, setShowUpdateOwnerLastContactModal] = useState(false);
  const [showUpdateOwnerLastContactModalQuestion, setShowUpdateOwnerLastContactModalQuestion] = useState(false);
  const [showUpdatePropertyCoordinatesModal, setShowUpdatePropertyCoordinatesModal] = useState(false);
  const [showNextAvailableModal, setShowNextAvailableModal] = useState(false);
  const [ownerContactDate, setOwnerContactDate] = useState(null);
  const [ownerContactDateError, setOwnerContactDateError] = useState(null);
  const [nextAvailableDate, setNextAvailableDate] = useState(null);
  const [nextAvailableError, setNextAvailableError] = useState(null);
  const [commentError, setCommentError] = useState(null);
  const [noteTextError, setNoteTextError] = useState(null);
  const [noteText, setNoteText] = useState(null);
  const [disabled, setDisabled] = useState(false);
  const [currentLat, setCurrentLat] = useState(null);
  const [currentLon, setCurrentLon] = useState(null);
  const [price, setPrice] = useState(null);
  const [images, setImages] = useState(null);
  const [showModalImage, setShowModalImage] = useState(false);
  const [errorImages, setErrorImages] = useState(null);
  const refImage = useRef(null);
  const [mountRefImages, setMountRefImages] = useState(null);
  const [multipleFiles, setMulitpleFiles] = useState(null);
  const [imagesFiles, setImagesFiles] = useState(null);
  const [propertyID, setPropertyID] = useLocalStorage(
    'propspropertyforsalecard',
    location?.state?.query?.property?.id,
  );
  const [userID] = useState(localStorage.getItem('userId'));
  const [staffMemberID] = useState(
    localStorage.getItem('staffMemberId'),
  );
  const [path, setPath] = useLocalStorage('Path', '');

  const [reasonDataLocalStorage, setReasonDataLocalStorage] =
    useLocalStorage('ReasonData', []);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    let token = localStorage.getItem('token');
    axios.defaults.headers.common[
      'Authorization'
    ] = `Bearer ${token}`;

    document.title = 'Property Details';
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setPropertyID(location?.state?.query?.property?.id);
    setOwnerContactDate(moment(location?.state?.query?.property?.ownerLastContacted).toDate());
    if (
      location?.state?.prevPath?.path !== undefined ||
      location?.state?.prevPath?.path !== null
    ) {
      setPath(
        location?.state?.prevPath?.path ||
          JSON.parse(localStorage.getItem('Path')),
      );
    }

    if (
      location?.state?.query?.property !== undefined ||
      location?.state?.query?.property !== null
    ) {
      setPropertyID(
        location?.state?.query?.property?.id ||
          JSON.parse(
            localStorage.getItem('propspropertyforsalecard'),
          ),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      location?.state?.prevPath?.path !== undefined ||
      location?.state?.prevPath?.path !== null
    ) {
      setPath(
        location?.state?.prevPath?.path ||
          JSON.parse(localStorage.getItem('Path')),
      );
    }

    if (
      location?.state?.query?.property !== undefined ||
      location?.state?.query?.property !== null
    ) {
      setPropertyID(
        location?.state?.query?.property?.id ||
          JSON.parse(
            localStorage.getItem('propspropertyforsalecard'),
          ),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    location?.state?.query?.property,
    location?.state?.prevPath?.path,
  ]);

  const fetchPropertyDetailsByID = (id) => {
    const options = {
      method: 'GET',
      url: `/property/getsummary/${id}`,
    };

    return axios
      .request(options)
      .then((response) => {

        //Retrieve Property Images
        const options2 = {
          method: 'GET',
          url: `/externalfile/GetByRecordContextType/${id}/3/1`, //3 is Property Document Context, 1 is FileType Image
        };

        return axios
          .request(options2)
          .then((response2) => {
            response.data.externalFiles = response2.data;
            console.log(response.data);
            return response.data;
          })
          .catch((error) => {});

      })
      .catch((error) => {});
  };

  const {
    isLoading: isLoadingPropertyDetails,
    data: dataPropertyDetails,
    refetch
  } = useQuery(
    ['propertydetails', propertyID],
    () => fetchPropertyDetailsByID(propertyID),
    {
      enabled: Boolean(propertyID),
    },
  );

  const reasonModal = (id) => {
    setShowModal(true);
    setPropertyID(id);
  };

  const priceModal = () => {
    if (dataPropertyDetails.forSaleOrToLet === false) {
      //Is for sale
      setPrice(dataPropertyDetails?.propertyForSale?.price.toString());
    } else {
      //Is to let
      setPrice(dataPropertyDetails?.propertyToLet?.longLetRate.toString());
    }
    setShowPriceModal(true);
  };

  const propertyUpdateCoordinatesModal = () => {
    setShowUpdatePropertyCoordinatesModal(true);
  };

  const uploadImagesModal = () => {
    setShowModalImage(true);
  };

  const nextAvailableModal = () => {
    setNextAvailableError(null);
    setShowNextAvailableModal(true);
  };

  const handleAddBuyerProperties = () => {
    navigate('/AddBuyerProperties', {
      state: {
        propertyId: propertyID,
      }
    })
  };

  const updateOwnerLastContactModal = () => {
    setShowUpdateOwnerLastContactModal(true);
  };

  const handleReasonChange = (event) => {
    setReasonError(null);
    setReason(event.value);
  };

  const handleComment = (e) => {
    setCommentError(null);
    setComment(e.target.value);
  };

  const handlePriceAutoComplete = () => {
    let priceMoney;
    if (price !== null && price !== '') {
      priceMoney = price
        .replace(/[ ,.]/g, '')
        .replace(/[K|k]/g, '*1000')
        .replace(/[M|m]/g, '*1000000')
        .replace(/[^0-9/*.]/g, '');

      var args = priceMoney.split('*');
      priceMoney = args.reduce((a, b) => a * b);
      let returnVal = numberWithCommas(priceMoney);
      setPrice(returnVal);
      return;
    }
    setPrice('');
  };

  const handlePriceChange = (e) => {
    setPrice(e.target.value.trim());
  };

  const handleUpdateOwnerLastContact = async (e) => {
    setDisabled(true);
    e.preventDefault();
    e.stopPropagation();
    if (!noteText) {
      setNoteTextError("Note Text input can't be empty");
      setDisabled(false);
      return;
    }

    const config = {
      method: 'POST',
      url: '/property/updateownerlastcontact',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        propertyId: propertyID,
        lastContactDate: ownerContactDate,
        noteText: noteText,
        staffMemberId: staffMemberID,
        username: localStorage.getItem('username')
      }),
    };

    try {
      const data = await axios(config);

      if (data.status === 200) {
        setNoteText(null);
        setDisabled(false);
        toast.success(
          `Owner last contact date has been updated.`,
          {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            draggable: true,
            progress: undefined,
          },
        );
        refetch();
      }
    } catch (err) {
      setDisabled(false);
      toast.error(
        `Sorry, property wasn't added, try again ${err.message}`,
        {
          position: 'top-left',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          draggable: true,
          progress: undefined,
        },
      );
      throw new Error(`server error`);
    }
    setReason(null);
    setComment(null);
    setShowModal(false);

    setShowUpdateOwnerLastContactModal(false);
  };

  const handleUpdateOwnerLastContactQuestion = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    let d = new Date();
    let isoDate = d.toLocaleString('en-US');

    const config = {
      method: 'POST',
      url: '/property/updateownerlastcontact',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        propertyId: propertyID,
        lastContactDate: isoDate,
        noteText: 'Updated by price or availability date change.',
        staffMemberId: staffMemberID,
        username: localStorage.getItem('username')
      }),
    };

    try {
      const data = await axios(config);

      if (data.status === 200) {
        setDisabled(false);
        toast.success(
          `Property last contact date has been updated`,
          {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            draggable: true,
            progress: undefined,
          },
        );
        //Trigger manual refetch
        refetch();
      }
    } catch (err) {
      setDisabled(false);
      toast.error(
        `Error ${err.message}`,
        {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          draggable: true,
          progress: undefined,
        },
      );
      throw new Error(`server error`);
    }
    setShowUpdateOwnerLastContactModalQuestion(false);
  };

  const handleUpdatePropertyCoordinates = async () => {
    const config = {
      method: 'POST',
      url: '/Property/UpdatePropertyCoordinates',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        Id: propertyID,
        GoogleMapLatitude: currentLat,
        GoogleMapLongitude: currentLon,
        UsernameSubmitted: localStorage.getItem('username')
      }),
    };

    try {
      const data = await axios(config);

      if (data.status === 200) {
        toast.success(
          `Property Coordinates Updated`,
          {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            draggable: true,
            progress: undefined,
          },
        );
        //Trigger manual refetch
        refetch();
      }
    } catch (err) {
      setDisabled(false);
      toast.error(
        `We are still determining your coordinates, please try again.`,
        {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          draggable: true,
          progress: undefined,
        },
      );
    }
    setShowUpdatePropertyCoordinatesModal(false);
  };

  const handleUpdatePropertyPrice = async () => {
    const config = {
      method: 'POST',
      url: '/Property/UpdatePropertyPrice',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        Id: propertyID,
        PriceSQ: price,
        AmendmentByStaffId: localStorage.getItem('staffMemberId'),
        UsernameSubmitted: localStorage.getItem('username')
      }),
    };

    try {
      const data = await axios(config);

      if (data.status === 200) {
        toast.success(
          `Property Price Updated`,
          {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            draggable: true,
            progress: undefined,
          },
        );
        //Trigger manual refetch
        refetch();
        setShowUpdateOwnerLastContactModalQuestion(true);
      }
    } catch (err) {

    }
    setShowPriceModal(false);
  };

  const handleUploadPropertyImages = async () => {
    let ftc = dataPropertyDetails?.propertyRef.substring(0, 2);
    let ffc = dataPropertyDetails?.propertyRef.substring(0, 4);
    if (disabled == true) return false;

    setDisabled(true);

    if (multipleFiles !== null) {
      const payload = await Promise.all(
        multipleFiles.map(async (file) => {
          var base64Image = file.data.replace(
            /^data:image\/[a-z]+;base64,/,
            '',
          );

          var dotIndex = file.filename.lastIndexOf('.');
          var ext = file.filename
            .substring(dotIndex)
            .toUpperCase()
            .replace(/\./g, '');

          var imagePath = `Property\\P${ftc}\\P${ffc}\\P${dataPropertyDetails?.propertyRef}\\O_${dataPropertyDetails?.propertyRef}_${file.filename}`;

          var ImagesRequestOptions = {
            method: 'POST',
            url: `/property/createanduploadpropertyextfile`,
            headers: {
              'Content-Type': 'application/json',
            },
            data: JSON.stringify({
              Base64File: `${base64Image}`,
              MetaData: {
                RecordId: 0,
                FileType: 1,
                Rating: 0,
                SequenceNo: 99,
                FileExtension: `${ext}`,
                FilePath: `${imagePath}`,
                Description: `Image Uploaded From Mobile`,
              },
              FileName: `${file.filename}.jpg`,
              PropertyRef: `${dataPropertyDetails?.propertyRef}`,
            }),
          };

          try {
            return await axios(ImagesRequestOptions);
          } catch (err) {}
        }),
      );

      if (payload) {
        toast.success(`Images Uploaded Successfully`, {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      setDisabled(false);
      setShowModalImage(false);
    }
  };

  const addFavourite = async (e, propertyRef) => {
    setDisabled(true);
    if (!reason) {
      setReasonError("Reason input can't be emptied");
      setDisabled(false);
      return;
    }
    if (!comment) {
      setCommentError("Comment input can't be emptied");
      setDisabled(false);
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    queryClient.invalidateQueries('Favourites');

    let d = new Date();
    let isoDate = d.toLocaleString('en-US');

    const config = {
      method: 'POST',
      url: '/propertyfavourite',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        propertyId: propertyID,
        sys_UserId: userID,
        dateRegistered: isoDate,
        propertyFavouriteReasonId: reason,
        comments: comment,
      }),
    };

    try {
      const data = await axios(config);
      if (data.status === 201) {
        setReason(null);
        setComment(null);
        setDisabled(false);
        toast.success(`Property: ${propertyRef} has been added`, {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,

          draggable: true,
          progress: undefined,
        });
      }
    } catch (err) {
      if (err)
        toast.error(
          `Sorry, property wasn't added, try again ${err.message}`,
          {
            position: 'top-left',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          },
        );
    }
    setReason(null);
    setComment(null);
    setShowModal(false);
  };

  const fetchReason = () => {
    const options = {
      method: 'GET',
      url: `/propertyfavouritereason`,
    };

    return axios
      .request(options)
      .then((response) => {
        let options = response.data.map((element) => {
          return { value: element.id, label: element.description };
        });
        return options;
      })
      .catch((error) => {});
  };

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { data: reasonData } = useQuery(['Reason'], fetchReason,
  { refetchOnWindowFocus: false }
  );

  useEffect(() => {
    setReasonDataLocalStorage(reasonData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reasonData]);

  const initialValue = '';

  const handleMobileNos = (numbers) => {
    var result = [];
    numbers.forEach(element => {
      result.push(<a href={'tel:' + element.prefix + element.telephoneNo}>{element.prefix + '-' + element.telephoneNo + ' '}</a>);
    });
    return result;
  };

  const mutation = useMutation(handleUpdateOwnerLastContact, {
    onMutate: async (id) => {
      await queryClient.cancelQueries('propertydetails');
      const previousValue = queryClient.getQueryData(
        ['propertydetails', id.id],
        {
          exact: false,
        },
      );

      let d = new Date();
      let isoDate = d.toLocaleString('en-US');

      const updatedValue = { ...previousValue };

      queryClient.setQueryData(['propertydetails', id.id], {
        ...updatedValue,
        ownerLastContacted: isoDate,
      });

      return { previousValue };
    },
    onError: (err, _id, context) => {
      queryClient.setQueryData(
        ['propertydetails', _id.id],
        context.previousValue,
      );
    },
  });

  const handleMap = (dataPropertyDetails, searchPath) => {
    navigate('/MapPerCard');
    dispatch(
      singlePropertyMap({
        property: dataPropertyDetails,
        searchPath: searchPath,
      }),
    );
  };

  const handleImgDownload = (url, filename) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const getCurrentLocation = function () {
    return new Promise(function (resolve, reject) {
      navigator.geolocation.getCurrentPosition(resolve, reject);
    });
  };

  const handleDeleteImage = (id) => {
    setImages((oldState) =>
      oldState.filter((item, index) => index !== id),
    );

    refImage.current.files = mountRefImages;

    const dt = new DataTransfer();
    Array.from(refImage.current.files).forEach((filev, index) => {
      if (id !== index) {
        dt.items.add(
          new File([filev], filev.name, { type: filev.type }),
        );
      }
    });

    let fileObj = [];

    fileObj.push(dt.files);

    setMountRefImages(dt.files);

    if (fileObj < 0) {
      return;
    }

    tobase64Handler(dt.files).then((data) => {
      setMulitpleFiles(data);
    });

    refImage.current.files = dt.files;
  };

  const tobase64Handler = async (files) => {
    const filePathsPromises = [];
    Array.from(files).forEach((file) => {
      filePathsPromises.push(toBase64(file));
    });
    const filePaths = await Promise.all(filePathsPromises);
    return filePaths;
  };
  
  //multiple images
  const toBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () =>
        resolve({ data: reader.result, filename: file.name });
      reader.onerror = (error) => reject(error);
    });
  };

  const handleUploadMultipleFiles = (e) => {
    e.persist();
    e.preventDefault();
    let fileObj = [];
    let fileArray = [];

    refImage.current.files = e.target.files ?? mountRefImages;

    fileObj.push(e.target.files);
    for (let i = 0; i < fileObj[0].length; i++) {
      if (fileObj[0][i].type !== 'image/jpeg') {
        setErrorImages((prevState) => ({
          ...prevState,
          type: 'Only images can be uploaded',
        }));
      }
      if (fileObj[0][i].size >= 10485760) {
        setErrorImages((prevState) => ({
          ...prevState,
          size: 'File too Big, please select a file less than 10mb',
        }));
      }
      fileArray.push(URL.createObjectURL(fileObj[0][i]));
    }

    setImages(fileArray);

    setImagesFiles([...fileObj]);

    if (e.target.files < 0 || !e.target.validity.valid) {
      return;
    }

    // refImage.current.files = e.target.files;
    tobase64Handler(e.target.files).then((data) => {
      setMulitpleFiles(data);
    });

    setMountRefImages(e.target.files);
  };

  const handleUpdateNextAvailableDate = async (e) => {
    setDisabled(true);
    if (!nextAvailableDate) {
      setNextAvailableError("Date is required");
      setDisabled(false);
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    let data = {
      PropertyId: parseInt(propertyID),
      LettingNextAvail: moment(nextAvailableDate).utc(true)
    };

    const config = {
      method: 'POST',
      url: '/Property/UpdatePropertyLettingNextAvail',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(data),
    };

    try {
      const data = await axios(config);
      if (data.status == 200 || data.status == 201) {
        setDisabled(false);
        toast.success(
          `Next Available Date Updated`,
          {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          },
        );
        setShowNextAvailableModal(false);
        //Trigger manual refetch
        refetch();
        setShowUpdateOwnerLastContactModalQuestion(true);
      }
    } catch (err) {
      if (err.response.status === 500)
      setComment('');
      setDisabled(false);
    }
  };

  useEffect(() => {
    getCurrentLocation()
      .then((position) => {
        setCurrentLat(position.coords.latitude);
        setCurrentLon(position.coords.longitude);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  if (isLoadingPropertyDetails) {
    return <CenteredSpinner />;
  }

  return (
    <div className="container p-0 mb-4">
      <div className='row ml-1'>
        <div className="col-9 col-xl-9 col-xl-9 ml-0 p-0">
          <div className="h4 mb-3 ml-0 font-weight-bold">
            Property Details
          </div>
        </div>
        <div className="col-3 col-md-3 col-xl-3 text-right">
          <p className="btn btn-outline-secondary d-block" onClick={() => navigate(-1)}>
            <i className="fas fa-arrow-left me-2" style={{ color: '#6c757d' }}></i>
            Back
          </p>
        </div>
      </div>
      <div className="card">
        {dataPropertyDetails?.externalFiles.length === 0 ? (
          <img
            src={noImage}
            alt="defaultImage"
            className="img-fluid w-100"
          />
        ) : (
          <div className="slide-container">
            <Swiper
              slidesPerView={1}
              navigation
              pagination={{
                dynamicBullets: true,
              }}
              onSlideChange={() => console.log('slide change')}
              onSwiper={(swiper) => console.log(swiper)}
            >
              {location?.state?.property?.externalFiles
                ? location?.state?.property?.externalFiles
                    ?.map((a) => {
                      return {
                        url: `${AppConstants.BASE_URL_FILE + a.filePath}`,
                      };
                    })
                    .map((slideImage, index) => (
                      <SwiperSlide key={index}>
                        <div style={{ position: 'relative' }}>
                          <img
                            src={slideImage.url}
                            alt="slider"
                            style={{
                              objectFit: 'cover',
                              maxHeight: '400px',
                              width: '100%',
                            }}
                          />
                          <a
                              href={slideImage.url}
                              download={`image-${index}.jpg`}
                              target='_blank'
                              style={{
                                position: 'absolute',
                                bottom: '10px',
                                right: '10px',
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                color: 'white',
                                padding: '5px 10px',
                                borderRadius: '5px',
                                textDecoration: 'none',
                              }}
                            >
                              Open
                          </a>
                        </div>
                      </SwiperSlide>
                    ))
                : dataPropertyDetails?.externalFiles
                    ?.map((a) => {
                      return {
                        url: `${AppConstants.BASE_URL_FILE + a.filePath}`,
                      };
                    })
                    .map((slideImage, index) => (
                      <SwiperSlide key={index}>
                        <div style={{ position: 'relative' }}>
                          <img
                            src={slideImage.url}
                            alt="slider"
                            style={{
                              objectFit: 'cover',
                              maxHeight: '400px',
                              width: '100%',
                            }}
                          />
                          <a
                            href={slideImage.url}
                            download={`image-${index}.jpg`}
                            target='_blank'
                            style={{
                              position: 'absolute',
                              bottom: '10px',
                              right: '10px',
                              backgroundColor: 'rgba(0, 0, 0, 0.5)',
                              color: 'white',
                              padding: '5px 10px',
                              borderRadius: '5px',
                              textDecoration: 'none',
                            }}
                          >
                            Open
                          </a>
                        </div>
                      </SwiperSlide>
                    ))}
            </Swiper>
          </div>
        )}
        <div className="card-body">
          <p
            className="mt-0 mb-1 card-text"
            style={{ fontSize: '14px' }}
          >
            <i
              className="fas fa-map-signs"
              style={{ color: '#243c64' }}
            ></i>{' '}
            {dataPropertyDetails?.localityName}
          </p>
          {dataPropertyDetails?.shortDescription !== null ? (
            <div className="mb-3">
              <span className="font-weight-bold mr-1">
                Property Short Name:{' '}
              </span>
              <p
                className="m-0 card-text"
                style={{ fontSize: '14px' }}
              >
                {dataPropertyDetails?.shortDescription}
              </p>
            </div>
          ) : null}

          <div className="d-flex flex-row justify-content-between align-items-center">
            <p
              className="m-0 card-text mb-2"
              style={{ fontSize: '14px' }}
            >
              <span className="font-weight-bold mr-1">Ref: </span>
              {dataPropertyDetails?.propertyRef}
            </p>
            <p
              className="m-0 card-text mb-2"
              style={{ fontSize: '14px' }}
            >
              <span className="font-weight-bold mr-1">Price: </span>€
              {dataPropertyDetails?.forSaleOrToLet === false
                ? numberWithCommas(
                    dataPropertyDetails?.propertyForSale?.price,
                  )
                : numberWithCommas(
                    dataPropertyDetails?.propertyToLet?.longLetRate,
                  ) + ' ' + dataPropertyDetails?.propertyToLet?.leaseRatePeriod}
            </p>
          </div>
          <span className="font-weight-bold mr-1 mb-2">
            Location:{' '}
          </span>
          <p className="m-0 card-text" style={{ fontSize: '14px' }}>
            {dataPropertyDetails?.addressLine1}
          </p>
          <p className="m-0 card-text" style={{ fontSize: '14px' }}>
            {dataPropertyDetails?.addressLine2}
          </p>
          <p className="mb-3 card-text" style={{ fontSize: '14px' }}>
            {dataPropertyDetails?.addressLine3}
          </p>

          {dataPropertyDetails?.shortDescription !== null ? (
            <div
              className="mb-3 card-text"
              style={{ fontSize: '14px' }}
            >
              <div className="font-weight-bold mr-1 mb-0">
                Owner:{' '}
              </div>
              <div className="font-weight-bold mr-1 mb-0">
                {dataPropertyDetails?.vendorAddressList?.map(
                  function (vendor, index) {
                    return vendor?.mainOwner === true ? (
                      <div className="d-block mb-2" key={index}>
                        <p className="mr-2 font-weight-bold d-inline">
                          {`${vendor?.ownerName}`}
                        </p>
                        {vendor?.address?.addressPhones.length !==
                          0 &&
                        vendor?.address?.addressPhones !== null ? (
                          <div className="inline">
                            <span className="font-weight-bold mr-1 mb-0 inline">
                              {vendor?.address?.addressPhones.length >
                              1
                                ? 'Telephones:'
                                : 'Telephone:'}
                            </span>
                            {handleMobileNos(
                              vendor?.address?.addressPhones
                            )}
                          </div>
                        ) : null}

                        {vendor?.address?.addressEmails?.map(
                          function (email, index) {
                            return (
                              <div key={index}>
                                <span className="font-weight-bold mr-1 mb-0 inline">
                                  {vendor?.address?.addressEmails
                                    .length > 1
                                    ? 'Emails:'
                                    : 'Email:'}
                                </span>
                                <a href={`mailto:${email?.emailAddress}`} className="text-primary">{`${email?.emailAddress}`}</a>
                              </div>
                            );
                          },
                        )}
                        <div className="mr-1 mb-0">
                          <span className="font-weight-bold mr-1 mb-0">
                            Last Contacted:
                          </span>
                          <Moment format="DD/MM/YYYY">
                            {dataPropertyDetails.ownerLastContacted}
                          </Moment>
                          <div
                            className="btn custom-inline-btn"
                            onClick={(e) => {
                              updateOwnerLastContactModal(dataPropertyDetails?.id);
                            }}
                          >
                            <Calendar size={20} />
                          </div>
                        </div>
                        <div>
                          <span className="font-weight-bold mr-1 mb-0 d-inline">
                            Viewings by:
                          </span>
                          {dataPropertyDetails.viewingsBy}
                        </div>
                        <div>
                          <span className="font-weight-bold mr-1 mb-0 d-inline">
                            Agent:
                          </span>
                          {dataPropertyDetails.viewingNegotiatorName}
                        </div>

                        {dataPropertyDetails.viewingsBy === 'KeysAtOffice' ? (
                          <div>
                            <span className="font-weight-bold mr-1 mb-0 d-inline">
                              Keys:
                            </span>
                            {dataPropertyDetails.propertyKeys?.map(
                              function (value, index) {
                                if (value.keyStatus != 'Withdrawn') {
                                  return (
                                    <span>{value?.keyRef?.split("_")[1] + value?.tagNo} </span> //BranchCode + Tag No
                                  );
                                }
                              },
                            )}
                          </div>
                        ) : null}
                      </div>
                    ) : null;
                  },
                )}{' '}
              </div>
              <p className="font-weight-bold mr-1 mb-0">
                {
                  dataPropertyDetails?.vendorAddressList
                    ?.addressIndividualSurname
                }
              </p>
              <p className="font-weight-bold mr-1 mb-0">
                {dataPropertyDetails?.ownerPhonesString}
              </p>
            </div>
          ) : null}
          <div
            className="mb-3 card-text"
            style={{ fontSize: '14px' }}
          >
            <p className="font-weight-bold mr-1 mb-1 h-3 ">
              Property Key Features:{' '}
            </p>
            {dataPropertyDetails?.forSaleOrToLet === true ? (
              <div className="mr-1 mb-0">
                <span className="font-weight-bold mr-1 mb-0">
                  Availability:
                </span>
                <Moment format="DD/MM/YYYY">
                  {
                    dataPropertyDetails?.propertyToLet
                      ?.lettingNextAvail
                  }
                </Moment>
                <div
                  className="btn custom-inline-btn"
                  onClick={nextAvailableModal}
                >
                  <Calendar size={20} />
              </div>
              </div>
            ) : null}
            <p className="mr-1 mb-0">
              <span className="font-weight-bold mr-1 mb-0">
                Bedrooms:
              </span>
              {dataPropertyDetails?.bedrooms}{' '}
            </p>
            <p className=" mr-1 mb-0">
              <span className="font-weight-bold mr-1 mb-0">
                Area:
              </span>
              {dataPropertyDetails?.areaSqMtrs} SqMtrs
            </p>
            <p className=" mr-1 mb-0">
              <span className="font-weight-bold mr-1 mb-0">
                Market status:
              </span>
              {dataPropertyDetails?.marketStatusCode}
            </p>
          </div>
          {dataPropertyDetails?.propertyDescription !== null ? (
            <div
              className="mb-3 card-text"
              style={{ fontSize: '14px' }}
            >
              <p className="font-weight-bold mr-1 mb-0">
                Property Description:{' '}
              </p>
              <p
                dangerouslySetInnerHTML={{
                  __html: dataPropertyDetails?.propertyDescription,
                }}
              ></p>
            </div>
          ) : null}
          {dataPropertyDetails?.internalComments !== null && dataPropertyDetails?.internalComments.length > 100 ? (
            <div
              className="mb-3 card-text"
              style={{ fontSize: '14px' }}
            >
              <p className="font-weight-bold mr-1 mb-0">
                Internal Comments:{' '}
              </p>
              <p
                dangerouslySetInnerHTML={{
                  __html: dataPropertyDetails?.internalComments,
                }}
              ></p>
            </div>
          ) : null}

          <div className="row w-70" style={{ paddingLeft: '10px' }}>
            {dataPropertyDetails?.googleMapLatitude !== null &&
            dataPropertyDetails?.googleMapLongitude !== null ? (
              <div
                className="btn col-3 d-block mb-2"
                onClick={() => {
                  handleMap(
                    dataPropertyDetails,
                    location?.state?.prevPath?.path,
                  );
                }}
              >
                <Map size={32} />
              </div>
            ) : null}

            {path !== '/Favourites' && path !== '/HotProperties' ? (
              <div
                className="btn col-3 d-block mb-2"
                onClick={(e) => {
                  reasonModal(dataPropertyDetails?.id);
                  e.stopPropagation();
                }}
              >
                <Heart size={32} />
              </div>
            ) : null}

            

            <div
              className="btn col-3 d-block mb-2"
              onClick={handleAddBuyerProperties}
            >
              <UserPlus size={32} />
            </div>

            <div
              className="btn col-3 d-block mb-2"
              onClick={uploadImagesModal}
            >
              <Image size={32} />
            </div>

            {dataPropertyDetails?.googleMapLatitude !== null &&
            dataPropertyDetails?.googleMapLongitude !== null ? (
              <div className="btn col-3 d-block mb-2">
                <a href={'https://www.google.com/maps/search/?api=1&query=' + dataPropertyDetails?.googleMapLatitude + ',' + dataPropertyDetails?.googleMapLongitude} 
                  className="font-weight-bold text-primary" target="_blank">
                    <NavigationIcon size={32} />
                </a>
              </div>
            ) : null}

            <div
              className="btn col-3 d-block mb-2"
              onClick={propertyUpdateCoordinatesModal}
            >
              <MapPin size={32} />
            </div>

            <div
              className="btn col-3 d-block mb-2"
              onClick={priceModal}
            >
              <DollarSign size={32} />
            </div>

            {dataPropertyDetails?.publishToWebsite === true && dataPropertyDetails?.showingOnWeb === true ? (
              <div className="btn col-3 d-block mb-2">
                <a
                  href={`https://wa.me/?text=${encodeURI(getSysSetting(AppConstants.SysSettingId_PropertyWebUrl)?.stringValue + dataPropertyDetails.propertyRef)}`}
                  target={'_blank'}
                >
                  <Share2 size={32} />
                </a>
              </div>
            ) : null}

            <div
              className="btn col-3 d-block mb-2"
            >
              <a
                  href={`https://wa.me/?text=${encodeURI(dataPropertyDetails.webReportUrl)}`}
                  target={'_blank'}
                >
                  <FileText size={32} />
                </a>
            </div>

          </div>
        </div>
      </div>
      <p
        className="btn btn-outline-secondary d-block mb-4"
        onClick={() => navigate(-1)}
      >
        <i className="fas fa-arrow-left me-2" style={{ color: '#6c757d' }}></i>
        Back
      </p>

      <Modal show={showModal} backdrop="static" centered>
        <Modal.Header
          closeButton
          onClick={() => {
            setReason(null);
            setReasonError(null);
            setCommentError(null);
            setShowModal(false);
          }}
        >
          <Modal.Title><span className='font-weight-bold'>Add To Favourites</span></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label className="form-label mb-2" htmlFor="reason">
            Reason:
          </label>
          <Select
            id="reason"
            className={`${reasonError && 'react-select'}`}
            classNamePrefix={`${reasonError && 'react-select'}`}
            onChange={handleReasonChange}
            isSearchable={true}
            options={reasonDataLocalStorage}
          />
          {reasonError && (
            <small
              className="text-danger"
              style={{ display: 'block' }}
            >
              {reasonError}
            </small>
          )}
          <label
            className="form-label block mb-2 mt-2"
            htmlFor="comments"
          >
            Comments:
          </label>
          <input
            id="comments"
            autoComplete="off"
            className={`form-control d-block w-100 ${
              commentError && 'border-danger'
            }`}
            type="text"
            value={comment}
            onChange={handleComment}
            name="comment"
            required
          />
          {commentError && (
            <small className="text-danger">{commentError}</small>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant={
              comment !== null && disabled === true
                ? 'success'
                : 'primary'
            }
            onClick={(event) =>
              addFavourite(event, dataPropertyDetails.propertyRef)
            }
            disabled={comment !== null && disabled === true}
          >
            {comment !== null && disabled === true
              ? 'Adding...'
              : 'Add'}
          </Button>
        </Modal.Footer>
      </Modal>

      <OwnerLastContactModal
        showModal={showUpdateOwnerLastContactModal}
        noteTextError={noteTextError}
        setNoteText={setNoteText}
        setNoteTextError={setNoteTextError}
        setShowModal={setShowUpdateOwnerLastContactModal}
        ownerContactDate={ownerContactDate}
        setOwnerContactDate={setOwnerContactDate}
        ownerContactDateError={ownerContactDateError}
        disabled={disabled}
        updateOwnerLastContact={handleUpdateOwnerLastContact}
      />

      <Modal
        show={showUpdateOwnerLastContactModalQuestion}
        backdrop="static"
        centered
      >
        <Modal.Header
          closeButton
          onClick={() => {
            setShowUpdateOwnerLastContactModalQuestion(false);
          }}
        >
          <Modal.Title><span className='font-weight-bold'>Owner Contacted Today</span></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label
            className="form-label block mb-2 mt-2"
            htmlFor="NoteText"
          >
            Have you contacted the owner of the property?
          </label>
          {noteTextError && (
            <small className="text-danger">{noteTextError}</small>
          )}
        </Modal.Body>
        <Modal.Footer>
        <Button
            variant='danger'
            onClick={() => {
              setShowUpdateOwnerLastContactModalQuestion(false);
            }}
          >
            No
          </Button>
          <Button
            variant={
              noteText !== null && disabled === true
                ? 'success'
                : 'primary'
            }
            onClick={(event) => {
              handleUpdateOwnerLastContactQuestion(event)
            }}
          >
            {noteText !== null && disabled === true
              ? 'Updating...'
              : 'Yes'}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showUpdatePropertyCoordinatesModal}
        backdrop="static"
        centered
      >
        <Modal.Header
          closeButton
          onClick={() => {
            setShowUpdatePropertyCoordinatesModal(false);
          }}
        >
          <Modal.Title><span className='font-weight-bold'>Update Property Location</span></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label
            className="form-label block mb-2 mt-2"
          >
            Are you sure you want to set current location as property coordinates?
          </label>
        </Modal.Body>
        <Modal.Footer>
        <Button
            variant='danger'
            onClick={() => {
              setShowUpdatePropertyCoordinatesModal(false);
            }}
          >
             No
          </Button>
          <Button
            variant='primary'
            onClick={(event) =>
              handleUpdatePropertyCoordinates(event)
            }
          > 
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showPriceModal} backdrop="static" centered>
        <Modal.Header
          closeButton
          onClick={() => {
            setPrice(null);
            setShowPriceModal(false);
          }}
        >
          <Modal.Title><span className='font-weight-bold'>Update Property Price</span></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label
            className="form-label block mb-2 mt-2"
            htmlFor="price"
          >
            New price:
          </label>
          <input
            id="price"
            autoComplete="off"
            className={`form-control d-block w-100 ${
              commentError && 'border-danger'
            }`}
            type="text"
            value={price}
            onChange={handlePriceChange}
            onBlur={handlePriceAutoComplete}
            name="price"
            placeholder="100k"
            required
          />
          {commentError && (
            <small className="text-danger">{commentError}</small>
          )}
        </Modal.Body>
        <Modal.Footer>
        <Button
            variant='danger'
            onClick={() => {
              setShowPriceModal(false);
            }}
          >
             Cancel
          </Button>
          <Button
            variant='primary'
            onClick={(event) =>
              handleUpdatePropertyPrice(event)
            }
          > 
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showModalImage} centered backdrop="static">
            <Modal.Header
              closeButton
              onClick={() => {
                setShowModalImage(false);
                setErrorImages(null);
              }}
            >
              <Modal.Title><span className='font-weight-bold'>Upload Property Images</span></Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {images !== null ? (
                <>
                  <div className="grid-container-images">
                    {(images || []).map((url, index) => (
                      <img
                        key={index}
                        src={url}
                        alt="property images"
                        height="200px"
                        style={{ objectFit: 'cover' }}
                        className=""
                        onClick={() => handleDeleteImage(index)}
                      />
                    ))}
                  </div>
                  <br />
                  {images !== null && images.length > 0 ? (
                    <button
                      onClick={() => {
                        setImages(null);
                        setMulitpleFiles(null);
                        setErrorImages(null);
                      }}
                      className="mt-2 mb-2 btn btn-primary"
                    >
                      {images.length > 1
                        ? 'Remove all images'
                        : 'Remove image'}
                    </button>
                  ) : null}
                </>
              ) : null}
              <p>
                {images?.length > 0
                  ? errorImages && errorImages.type
                  : null}
              </p>
              <p>
                {images?.length > 0
                  ? errorImages && errorImages.size
                  : null}
              </p>
              <br />
              <div className="form-group">
                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => handleUploadMultipleFiles(e)}
                  accept="image/*"
                  multiple
                  ref={refImage}
                />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant='danger'
                onClick={() => {
                  setShowModalImage(false);
                }}
              >
                Cancel
              </Button>
              {multipleFiles !== null && multipleFiles.length > 0 ? (
                <button
                  onClick={() => {
                    handleUploadPropertyImages();
                  }}
                  className="mt-2 mb-2 btn btn-primary"
                >
                  {disabled === true
                  ? 'Saving...'
                  : 'Save'}
                </button>
              ) : null}
            </Modal.Footer>
          </Modal>
          <UpdateNextAvailableDateModal
            showModal={showNextAvailableModal}
            setNextAvailableError={setNextAvailableError}
            setShowModal={setShowNextAvailableModal}
            nextAvailableDate={nextAvailableDate}
            setNextAvailableDate={setNextAvailableDate}
            nextAvailableError={nextAvailableError}
            disabled={disabled}
            updateNextAvailableDate={handleUpdateNextAvailableDate}
        />
    </div>
  );
};
